import React from "react";
import capitalize from "lodash/capitalize";
import RegistrationCard from "../RegistrationCard";
import { SubmissionError } from "redux-form";
import ContactInfoForm from "./ContactInfoForm";
import { findContactConflicts } from "../../../common/contactConflicts";

const ContactInfoPage = ({ currentRegistration, onSubmit }) => {
  const { firstName, lastName, email, phone } = currentRegistration;

  const submitIfUnused = async (values) => {
    const conflicts = await findContactConflicts(values, currentRegistration.customer);
    if (conflicts) throw new SubmissionError(conflicts);
    return onSubmit(values);
  };

  return (
    <RegistrationCard
      title="Enter your contact information"
      subtitle="The email address used here will receive registration documents for your records."
      positiveActionLabel="Save & Continue"
    >
      <ContactInfoForm
        onSubmit={submitIfUnused}
        initialValues={{
          firstName: capitalize(firstName),
          lastName: capitalize(lastName),
          email,
          phone
        }}
      />
    </RegistrationCard>
  );
};

ContactInfoPage.propTypes = {};
ContactInfoPage.defaultProps = {};

export default ContactInfoPage;



// WEBPACK FOOTER //
// ./src/registration/components/ContactInfo/ContactInfoPage.jsx